// extracted by mini-css-extract-plugin
export default {"Rcard":"ReferralCard_Rcard__b1x4f","ReferralTxt":"ReferralCard_ReferralTxt__J1o2c"};